export const RightArrow = (color) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
            d="M7.04889 1.34727L12.4622 7.04297L0 7.04297L0 8.95703H12.5244L7.04889 14.6434L8.34667 16L16 8.04646L8.34667 1.94965e-07L7.04889 1.34727Z"
            fill="#007AC2"
        />
    </svg>
);
